function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { MODE } from "../../src/Renderer/PointsMaterial";
export default {
  initTools: function initTools(view, layer, datUi) {
    var update = function () {
      return view.notifyChange(layer, true);
    };

    layer.debugUI = datUi.addFolder("".concat(layer.id));
    layer.debugUI.add(layer, 'visible').name('Visible').onChange(update);
    layer.debugUI.add(layer, 'sseThreshold').name('SSE threshold').onChange(update);
    layer.debugUI.add(layer, 'octreeDepthLimit', -1, 20).name('Depth limit').onChange(update);
    layer.debugUI.add(layer, 'pointBudget', 1, 15000000).name('Max point count').onChange(update);
    layer.debugUI.add(layer.object3d.position, 'z', -50, 50).name('Z translation').onChange(function () {
      layer.object3d.updateMatrixWorld();
      view.notifyChange(layer);
    });
    layer.dbgStickyNode = '';
    layer.dbgDisplaySticky = false;
    layer.dbgDisplayChildren = true;
    layer.dbgDisplayParents = true;
    var styleUI = layer.debugUI.addFolder('Styling');

    if (layer.material.mode != undefined) {
      styleUI.add(layer.material, 'mode', MODE).name('Display mode').onChange(update);
      styleUI.add(layer, 'maxIntensityRange', 0, 1).name('Intensity max').onChange(update);
    }

    styleUI.add(layer, 'opacity', 0, 1).name('Layer Opacity').onChange(update);
    styleUI.add(layer, 'pointSize', 0, 15).name('Point Size').onChange(update);

    if (layer.material.picking != undefined) {
      styleUI.add(layer.material, 'picking').name('Display picking id').onChange(update);
    } // UI


    var debugUI = layer.debugUI.addFolder('Debug');
    debugUI.add(layer.bboxes, 'visible').name('Display Bounding Boxes').onChange(update);
    debugUI.add(layer, 'dbgStickyNode').name('Sticky node name').onChange(update);
    debugUI.add(layer, 'dbgDisplaySticky').name('Display sticky node').onChange(update);
    debugUI.add(layer, 'dbgDisplayChildren').name('Display children of sticky node').onChange(update);
    debugUI.add(layer, 'dbgDisplayParents').name('Display parents of sticky node').onChange(update);

    var isInHierarchy = function (name1, name2) {
      return layer.dbgDisplaySticky && name1 === name2 || layer.dbgDisplayParents && name1.startsWith(name2) || layer.dbgDisplayChildren && name2.startsWith(name1);
    };

    view.addFrameRequester('before_layer_update', function () {
      if (layer.dbgStickyNode.length) {
        layer.displayedCount = 0;
        var stickies = layer.dbgStickyNode.split(',');

        var _iterator = _createForOfIteratorHelper(layer.group.children),
            _step;

        try {
          var _loop = function () {
            var pts = _step.value;
            pts.visible = stickies.some(function (name) {
              return isInHierarchy(name, pts.owner.name);
            });

            if (pts.boxHelper) {
              pts.boxHelper.visible = pts.visible;
            }

            if (pts.visible) {
              layer.displayedCount += pts.geometry.attributes.position.count;
            }
          };

          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            _loop();
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    });
  }
};